import React from 'react';

import CardItem from '../../../../../components/CardItem';

export default function ProductsCardItem(props) {
    return (
        <CardItem
            bodyOptions={
                <>
                    {
                        props.gap > 0 ?
                            <span className="tag strong red">
                                {
                                    !props.criticalMode ?
                                    "CRÍTICO"
                                    : `${props.gap} UNIDADES`
                                }
                            </span>
                            : []
                    }
                    <span className="tag">COD {props.code}</span>
                </>
            }
            onClick={props.onClick}
        >
            <h4><b>{props.tittle}</b></h4>
            <p>{props.quantity} {props.quantity === 1 ? "unidade" : "unidades"}</p>
        </CardItem>
    )
}